import { render } from "./DocumentStep.vue?vue&type=template&id=1b4d80e6"
import script from "./DocumentStep.vue?vue&type=script&lang=js"
export * from "./DocumentStep.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__